import type { ICompareItem } from 'hooks/use-compare-colors/use-compare-colors.types'
import { GLOBAL_TAXONOMY_TERRITORY_TYPES } from 'modules/global-topic/common/global-topic.consts'

export function getGlobalTaxonomyCompareItems(filters?: Partial<Record<string, ICompareItem[]>>): ICompareItem[] {
  return GLOBAL_TAXONOMY_TERRITORY_TYPES.flatMap(type => filters?.[type] ?? [])
}
